import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: false,
};

export const initFacebookPixel = () => {
  const PIXEL_ID = "963134622257005";
  if (PIXEL_ID) {
    ReactPixel.init(PIXEL_ID, {}, options);
  }
};

export const trackPageView = () => {
  ReactPixel.pageView();
};

export const trackEvent = (event, data) => {
  ReactPixel.track(event, data);
};
// // old 
export const FB_PIXEL_ID = "963134622257005"; // Your Pixel ID

export const pageview = () => {
  window.fbq("track", "PageView");
};

export const event = (name, options = {}) => {
  window.fbq("track", name, options);
};
